import useBranch from "@/shared/atoms/useBranch";
import { useModalMeta } from "@/shared/atoms/useModal";
import useCommon from "@/shared/hooks/useCommon";
import { useState } from "react";
import BooleanWithLabel from "../Boolean/BooleanWithLabel";
import Map from "../Map/Map";
import Modal, { ModalProps } from "../Modal/Modal";

const OrderProductsModal = ({ onExit, ...props }: ModalProps) => {
  const [heatmap, setHeatmap] = useState(false);
  const [meta] = useModalMeta();
  const t = useCommon();
  const [branchData] = useBranch();
  return (
    <Modal width={"100rem"} onExit={onExit} {...props}>
      <Map
        showHeatmap={heatmap}
        branch={branchData}
        zoom={13}
        orders={meta?.orders ?? []}
      />
      <BooleanWithLabel
        onChange={(e) => setHeatmap(e.target.checked)}
        value={heatmap}
      >
        {t("showAsHeatMap")}
      </BooleanWithLabel>
    </Modal>
  );
};

export default OrderProductsModal;
